<template>
  <div id="results">
    <div v-if="$root.fittings.length">
      <p>
        Below are {{ $root.isBottomType ? "bottoms" : "bras" }} recommended just
        for you!
      </p>

      <div
        class="flex"
        style="justify-content: space-around; flex-wrap: wrap; gap: 10px"
      >
        <div class="confidence-container">
          <div class="confidence-table">
            <div class="flex">
              <div style="width: 115px">VERY HIGH -</div>
              <div>Above 90% fit confidence</div>
            </div>
            <div class="flex">
              <div style="width: 115px">HIGH -</div>
              <div>70% - 89.9% fit confidence</div>
            </div>
          </div>
        </div>

        <div>
          <filters v-if="$root.filters.length" />
          <sort_by />
        </div>
      </div>

      <template>
        <result
          v-for="product in $root.fittings"
          :key="product.shopify_id"
          :product="product"
        />
      </template>
    </div>
    <p v-if="$root.fittings && !$root.fittings.length">
      Sorry, no products match your search!<br />
      Please message us using the Contact Us tab or send us a message via our
      Facebook/Instagram so we can help you find a perfect
      {{ $root.isBottomType ? "bottom" : "bra" }}.
    </p>
    <p v-if="!$root.fittings">Loading...</p>
  </div>
</template>

<script>
import result from "./result.vue";
import sort_by from "../../components/sort_by.vue";
import filters from "../../components/filters.vue";

import save_size from "../functions/save_size";

export default {
  components: {
    result,
    sort_by,
    filters,
  },
};
</script>

<style lang="less" scoped>
#results {
  vertical-align: top;
  margin-top: 55px;
}
.confidence-container {
  max-width: 1024px;
  text-align: left;
}
.confidence-table {
  display: inline-block;
  padding: 5px 8px;
  text-align: left;
  border: 1px solid grey;
}
.flex {
  display: flex;
}
</style>
